export default function SVGBeat({ opacity }) {
  return (
    <g style={{ willChange: 'opacity' }} opacity={opacity}>
      <path
        d="M864.27,8669.57c6.79-2.1,13.57-4.23,20.36-6.34,4.79,5.51,9.64,11,14.44,16.47l12.83-14.59c1.19,39.13,2.06,98.26,3.17,137.39,6.95-75.1,18-161.37,29.48-235.8.79,41.09,3.37,82.17,3.49,123.26q7.07-10.63,14.15-21.25c3.1,4.71,6.22,9.4,9.3,14.11,16.44,2.07,31.52,0,49.25.71,5.12.21,9.09-4.7,13.63-7.08q6.39,9.55,12.72,19.17c4.73-4.3,9.4-8.63,14.08-13-2.78,45.69,0,80.31,1.33,126,6.91-84.35,15.32-157.19,23.68-241.42,3,39.59,6.09,91.15,9.44,130.72,4.1-7.32,8.24-14.62,12.29-22,3.4,4.2,6.82,8.38,10.23,12.58,17.88.17,35.68.24,53.51,1.79,4.09-2.48,8.4-4.63,12.41-7.24,4.83,6.27,9,8,13.58,14.46,4.19-4.62,8.53-16.1,12.7-20.75.42,43.36-1.43,87.83-1.5,131.23,9.18-76.9,13.38-154.76,22.24-231.66,2.16,41.76,6.79,86.1,8.07,127.84,1.17-2,2.19-3.75,3.11-5.44a42,42,0,0,1,26.76-20.71c6-1.5,11.65-2.81,13.9-2.24"
        fill="none"
        stroke="#f7f7f7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </g>
  );
}

export function MobileSVGBeat({ opacity }) {
  return (
    <g style={{ willChange: 'opacity' }} opacity={opacity}>
      <path
        d="M303.1,5577.2l8.3-2.6c2,2.2,3.9,4.5,5.9,6.7l5.2-5.9c.5,15.9.9,40,1.3,55.9,2.8-30.5,7.3-65.6,12-95.9.3,16.7,1.4,33.4,1.4,50.1l5.8-8.6,3.8,5.7c6.7.9,12.8,0,20,.3,2.1.1,3.7-1.9,5.5-2.9l5.2,7.8c1.9-1.7,3.8-3.5,5.7-5.3-1.1,18.6,0,32.6.5,51.2,2.8-34.3,6.2-63.9,9.6-98.1,1.2,16.1,2.5,37.1,3.8,53.1,1.7-3,3.3-6,5-8.9l4.1,5.1c7.3.1,14.5.1,21.8.7,1.7-1,3.5-1.9,5-3,2,2.6,3.7,3.3,5.5,5.9,1.7-1.9,3.5-6.5,5.2-8.4.2,17.6-.6,35.7-.6,53.4,3.7-31.3,5.4-62.9,9-94.2.9,17,2.8,35,3.3,52,.5-.8.9-1.5,1.3-2.2a16.86,16.86,0,0,1,10.9-8.4c2.4-.6,4.7-1.1,5.7-.9"
        fill="none"
        stroke="#f7f7f7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  );
}
